const normalizeText = (value = "") => value.toString().trim().toLowerCase();

export const RECRUITMENT_TYPE_KEY = "recrutamento-e-selecao";

export const normalizeInterviewTypeKey = (value, fallback = "pesquisa-de-compliance") => {
  const type = normalizeText(value);
  if (!type) return fallback;

  if (type === "recrutamento" || type === RECRUITMENT_TYPE_KEY) {
    return RECRUITMENT_TYPE_KEY;
  }

  if (type === "clima") return "pesquisa-de-clima";
  return type;
};

export const isRecruitmentType = (value) => {
  return normalizeInterviewTypeKey(value, "") === RECRUITMENT_TYPE_KEY;
};

